import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getActivitiesForCategory } from "../../../services/CallApi";
import ApiURL from "../../../services/ApiURL";
import { OndemandHocCarousel } from "../VideoUI/VideoUI";
import { ErrorUI } from "../../UI/Modals/Modals";
export default function ClassesForCategoryCarousel({
  category,
  shouldHitApi,
  activities,
}) {
  const { defaultGym } = useSelector((state) => state.profile.profileData);
  const [classes, setClasses] = useState([]);
  useEffect(() => {
    if (defaultGym && shouldHitApi) {
      getClassesforCategory();
    }
  }, [defaultGym]);
  const getClassesforCategory = () => {
    const payload = {
      offset: 0,
      limit: 100,
      category_id: category.category_id,
      gym_id: defaultGym.gym_id,
      section_name: JSON.stringify(["ondemand_classes"]),
    };
    getActivitiesForCategory(ApiURL._listActivitesForCategory, payload).then(
      async (res) => {
        if (res.status) {
          setClasses(res.list.ondemand_classes);
        } else {
          ErrorUI(res.list, () => {
            getClassesforCategory();
          });
        }
      }
    );
  };
  if (classes.length) {
    return (
      <OndemandHocCarousel
        heading={category.category_name}
        shouldHitApi={false}
        apiData={classes}
        showNewTag={false}
      />
    );
  } else {
    return activities && activities.length ? (
      <OndemandHocCarousel
        heading={category.category_name}
        shouldHitApi={false}
        apiData={activities}
        showNewTag={false}
      />
    ) : null;
  }
}
